const translationEn ={
  navTel: "Helpline",
  email: "E-mail",

  home:"Home",

  logo1: "Center for the development of professional ",
  logo2: "qualification of medical workers",
  logo3: "1 - department of ultrasound diagnostics",

  kafedra: "Department",
  kafedra1: "History",
  kafedra2: "Professor-teachers",
  kafedra3: "Portfolio of professor-teachers",
  kafedra4: "Information",
  kafedra5: "Scientific publications of professor-teachers",

  xujjatlar: "Regulatory documents",
  xujjatlar1: "Presidential decrees",
  xujjatlar2: "Orders of the Ministry of Health",
  xujjatlar3: "Center commands",
  xujjatlar4: "Programs",
  xujjatlar5: "Working programs",
  xujjatlar6: "Calendar plan",
  xujjatlar7: "Lesson schedule",

  faoliyat: "Activity",
  faoliyat1: "Educational activities",
  faoliyat2: "Scientific activity",
  faoliyat3: "Methodical organizational activity",
  faoliyat4: "Daily activity",

  tinglovchilar: "Trainees",
  tinglovchilar1: "Information for listeners",
  tinglovchilar2: "Video lectures",

  news: "News",
  news1: "Announcements",
  news2: "Conferences",

  contact:"Contacts",

  carsuelTittle: "1 - department of ultrasound diagnostics",

  resultsTittle: "Toward the health of the nation through continuing education",
  resultsCardbody1: "history of annual medical education",
  resultsCardbody2: "regional branches",
  resultsCardbody3: "academic staff",
  resultsCardbody4: "high-tech simulation centers",
  resultsCardbody5: "Faculties",
  resultsCardbody6: "Academicians",
  resultsCardbody7: "Scientific schools",
  resultsCardbody8: "Departments in the best centers and clinics",
  resultsCardbody9: "Doctors of Science and Candidates of Science",
  
  sitetittle: "Useful links",

  footerTittle: "Social networks:",
  footer1: "Address:",
  footer2: "29 Aviasozlar street, Yashnabad district, Tashkent",
  footer3: "Working time:",
  footer4: "Procedure:",
  footer5: "Monday - Friday, 8:30 - 14:30",
  footer6: "Days off:",
  footer7: "Saturday, Sunday",


  tarixtittle: "History",
  tarix1: "Abdufattev Ulugbek Avazjanovich",
  tarix2: "Download",
  tarix3: "Alimov Rustam Rakhimovich",
  tarix4: "Download",
  tarix5: "Jo'raev Zakhidjon Abdujalilovich",
  tarix6: "Download",
  tarix7: "Zakhidova Nodira Akhmadovna",
  tarix8: "Download",
  tarix9: "Israilova Mahpuza Khalilovna",
  tarix10: "Download",
  tarix11: "Qodirov Nodirbek Abdulkahorovich",
  tarix12: "Download",
  tarix13: "Qurbonov Furqat Turdiyevich",
  tarix14: "Download",
  tarix15: "Qurbonova Vusala Vidadievna",
  tarix16: "Download",
  tarix17: "Rozikhodjaeva Gulnora Akhmedovna",
  tarix18: "Download",
  tarix19: "Khasanov Izzatilla G'aybilloyevich",
  tarix20: "Download",
  tarix21: "Khojaqulov Odiljon Alisherovich",
  tarix22: "Download",
  tarix23: "Ikramova Zulfiya To'lqinovna",
  tarix24: "Download",
  tarix25: "Ikramova Zulfiya To'lqinovna",
  tarix26: "Download",
  tarix27: "Normurodova Nodira Muradullayevna",
  tarix28: "Download",
  tarix29: "Rasulova Munisa Mirmislimovna",
  tarix30: "Download",
  tarix31: "Fazilov Akram",
  tarix32: "Download",
  tarix33: "Miryusupov Mirqosim Mirsamatovich",
  tarix34: "Download",
  tarix35: "Niyazov Aziz Nabiyevich",
  tarix36: "Download",
  tarix37: "Sipova G'uzaloy G'ulomidinovna",
  tarix38: "Download",


  darsTittle: "Lesson Schedule",
  darsopen: "Open",
  darssave: "Save",
  dars1: "Prenatal Ultrasound Diagnosis of Congenital Defects",
  dars2: "CLINICAL ULTRASOUND DIAGNOSIS",
  dars3: "Doppler Technology in Obstetric Practice",
  dars4: "Clinical Neurosonography",
  dars5: "Innovative Technologies in Ultrasound Mammography",

  prezidentTittle: "Presidential decrees",

  ssvTittle: "Ministry of Health orders",

  markazTittle: "Center orders",

  dasturTittle: "Programs",
  dastur1: "Fundamentals of Fetal Echocardiography",
  dastur2: "Clinical Application of BI-RADS Classification in Ultrasound Mammography",
  dastur3: "Ultrasound Diagnosis of Uterine Myoma",
  dastur4: "Clinical Application of O-RADS Classification in Diagnosing Ovarian Masses",
  dastur5: "Application of FAST, BLUE, RUSH Ultrasound Examination Protocols in Emergency Patients",
  dastur6: "Clinical Neurosonography",
  dastur7: "Modern Technologies of Ultrasound Diagnostics in Phlebology",
  dastur8: "Principles of Operating Ultrasound Diagnostic Devices and Optimizing Echographic Images",
  dastur9: "Doppler Technology in Obstetric Practice",
  dastur10: "Fetal Echocardiography: Diagnosis of Congenital Heart Defects",
  dastur11: "Innovative Technologies in Ultrasound Mammography",
  dastur12: "Ultrasound Elastography Technologies in Clinical Practice",
  dastur13: "Prenatal Ultrasound Diagnosis of Congenital Defects",
  dastur14: "Comprehensive Ultrasound Diagnosis of the Vascular System",
  dastur15: "Selected Issues of Ultrasound Diagnosis in Obstetric Practice",
  dastur16: "Ultrasound Diagnosis and Treatment Methods for Kidney Stones and Their Complications",
  dastur17: "Selected Issues of Ultrasound Diagnosis in Urology Practice",
  dastur18: "Fundamentals of Ultrasound Diagnosis in Obstetric Practice",



  contactTittle: "Contact Us",
  contact1: "Address:",
  contact2: "Tashkent city, M.Ulugbek district, Parkent street, 51",
  contact3: "Contact number:",
  contact4: "Email:",
  contact5: "Working hours:",
  contact6: "Website:",
  contact7: "Lunch:",

    

  workingPrograms1: "Principles of managing ultrasound diagnostic equipment",
  workingPrograms2: "Innovative technologies in ultrasound mammography",
  workingPrograms3: "Modern technologies of ultrasound diagnostics in phlebology",
  workingPrograms4: "Clinical comprehensive ultrasound diagnostics of the vascular system",
  workingPrograms5: "Prenatal ultrasound diagnostics of congenital anomalies",
  workingPrograms6: "Selected methods of ultrasound diagnostics in urology practice",
  workingPrograms7: "Clinical ultrasound diagnostics",
  workingPrograms8: "Ultrasound diagnostics of uterine fibroids",
  workingPrograms9: "O-RADS classification for diagnosing ovarian masses",
  workingPrograms10: "BI-RADS ultrasound in mammography",
  workingPrograms11: "FAST, BLUE, RUSH ultrasound examinations in emergency patients",
  workingPrograms12: "Basics of fetal echocardiography ultrasound",
  workingPrograms13: "Doppler ultrasound technologies in obstetric practice",
  workingPrograms14: "Clinical neurosonography ultrasound",
  workingPrograms15: "Elastography technologies in clinical ultrasound diagnostics",

  siteLink1: "Ministry of Health of the Respublic of Uzbekistan",
  siteLink2: "Official web-site of the President of Uzbekistan",
  siteLink3: "Unified portal of interactive public services",

  test: "The site is in test mode because the data is not fully loaded",

}

export default translationEn
